// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PurchaseResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Purchase initiation response — returned by POST /ai/credits/purchase.
 *
 * purchase_id  — the pending row id (use with GET /ai/credits/purchase/{id}/status)
 * status       — always 'pending' on initiation; confirmed/failed after webhook
 * checkout_url — provider-hosted payment page to redirect the user to
 * charge_id    — provider charge id (used by the webhook to match the confirmed event)
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_PurchaseResponseDados {
purchase_id: number
status: string
checkout_url: string
charge_id: string
}

export type AiCredits_PurchaseResponse = ApiResponse<AiCredits_PurchaseResponseDados>;

registerResponseContract('AiCredits_PurchaseResponse', {
  purchase_id:  { type: 'number',  required: true },
  status:       { type: 'string',  required: true },
  checkout_url: { type: 'string',  required: true },
  charge_id:    { type: 'string',  required: true },
})
